var module = angular.module('octopusApp.infrastructure');
import React from 'react';

var Card = React.createClass({
    propTypes: {
        logoUrl: React.PropTypes.string.isRequired,
        title: React.PropTypes.string.isRequired,
        content: React.PropTypes.string.isRequired,
        footer: React.PropTypes.element
    },
    render : function() {
        return  <li className="card col-lg-2 col-md-3 col-sm-3 col-xs-4">
                    <div className="card-content animated">
                        <div className="logo logo-md"> <img src={this.props.logoUrl} /></div>
                        <div className="card-details">
                            <h5>{this.props.title}</h5>
                            <p>{this.props.content}</p>
                        </div>
                        <div className="card-footer background-blue">
                            <span>card-footer background-blue</span><i className="fontoctopus-octopus"></i>
                        </div>
                        <div className="add-action">
                            <button className="btn btn-success add" type="button">Add step</button>
                            <div className="add-action-details add-action-details-installed">
                            </div>
                        </div>
                    </div>
                </li>
    }
});

var CardBlock = React.createClass({
    propTypes: {
        data: React.PropTypes.array.isRequired
    },
    render : function() {
        return  <ol class="card-block">
                    { this.props.data.map(item => {
                                            return <Card title={item.title} content={item.content} logoUrl={item.logoUrl}></Card>
                                        })
                    }
                </ol>
    }
});


module.directive('cardBlock', function (reactDirective) {
  return reactDirective(CardBlock);
});






// WEBPACK FOOTER //
// ./app/infrastructure/style-guide/components.jsx